import { createFileRoute } from "@tanstack/react-router";
import { IntegrateProtectApiPage } from "@/features/agent-integrate/pages/protect-api-page";

// Thin shim: the resource-side no-bypass guidance — the step that turns "route through
// the edge" from a convention into a boundary.
export const Route = createFileRoute("/_authed/tenants/$slug/agents/integrate/protect")({
  component: IntegrateProtectApiPage,
});
